export default __webpack_public_path__ + "assets/moldova-flag.png";